import { ChangeDetectorRef, Component, DestroyRef, ElementRef, OnInit, ViewChild, inject, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PrivacyService } from '../../services/privacy/privacy.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-navbar',
  standalone: false,
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent implements OnInit {
  private readonly hideLangSignState = signal(false);
  private readonly destroyRef = inject(DestroyRef);
  get hideLangSign() { return this.hideLangSignState(); }
  set hideLangSign(value: boolean) { this.hideLangSignState.set(value); }
  @ViewChild('en') enButton: ElementRef | undefined;
  @ViewChild('bm') bmButton: ElementRef | undefined;
  constructor(private route: Router, private privacyService: PrivacyService, private translateService: TranslateService,
    private elementRef: ElementRef, private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.privacyService.hideLangSign.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
      this.hideLangSign = value;
      this.enButton?.nativeElement.click();
      this.changeDetectorRef.detectChanges();
    });
    this.route.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.route.url === '/') {
          this.hideLangSign = false;
        } else {
          this.hideLangSign = true;
        }
        this.changeDetectorRef.detectChanges();
      }
    });

  }
  goToLanding() {
    this.route.navigate(['']);
  }
  changeLanguage(language: string, event: any) {
    if (language === 'BM' && this.hideLangSign) {
      this.bmButton?.nativeElement.classList.remove('active');
      this.bmButton?.nativeElement.classList.remove('show');
      this.enButton?.nativeElement.classList.add('active');
      this.enButton?.nativeElement.classList.add('show');
      event.preventDefault();
      event.stopPropagation();
      return;
    } else {
      this.translateService.use(language);
    }
  }
}
